import React from 'react';
import { useSelector } from 'react-redux';
import { BodyText, Checkbox, Table } from '@gaiads/telia-react-component-library';
import { BundleOverview, LocaleResponse } from '@cdaas/api-clients/dist/product-service-openapi';

import ArrowButton from '../../../shared/ListUtil/ArrowButton';
import LanguageList from '../../../shared/ListUtil/LanguageList';
import SalesChannelInfo from '../../../shared/ListUtil/SalesChannelInfo';
import { RootState } from '../../../store';
import { selectAllSalesChannels } from '../../../store/salesChannels';

interface BundleListItemProps {
  children?: JSX.Element | JSX.Element[];
  item: BundleOverview;
  open: boolean;
  selected: boolean;
  locales: LocaleResponse[];
  onItemChecked: (bundleId: number) => void;
  onRowClick: (bundleId: number) => void;
  onOpenRow: (bundleId: number) => void;
}

const BundleListItem = ({ children, item, locales, selected, open, onItemChecked, onRowClick, onOpenRow }: BundleListItemProps) => {
  const { id, locale_ids, brand, name, sales_channel_uuids } = item;
  const allSalesChannels = useSelector((state: RootState) => selectAllSalesChannels(state));

  const toggleListItem = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    onOpenRow(id);
  };

  return (
    <>
      <Table.Row className="telia-react-table_row__master">
        <Table.Cell type="checkbox">
          <Checkbox checked={selected} onChange={() => onItemChecked(id)} onClick={event => event.stopPropagation()} />
        </Table.Cell>
        <Table.Cell>
          <ArrowButton open={open} onClick={toggleListItem} />
        </Table.Cell>
        <Table.Cell className="daas-product-table__brand" onClick={() => onRowClick(id)}>
          <BodyText>{brand}</BodyText>
        </Table.Cell>
        <Table.Cell className="daas-product-table__name" onClick={() => onRowClick(id)}>
          <BodyText>{name}</BodyText>
        </Table.Cell>
        <Table.Cell></Table.Cell>
        <Table.Cell></Table.Cell>
        <Table.Cell>
          <LanguageList languages={locale_ids} locales={locales} />
        </Table.Cell>
        <Table.Cell>
          <SalesChannelInfo allSalesChannels={allSalesChannels} variantSalesChannelUuids={sales_channel_uuids} />
        </Table.Cell>
        <Table.Cell></Table.Cell>
      </Table.Row>
      {children}
    </>
  );
};

export default BundleListItem;
